import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {AdController, AdService} from 'legacy-advertising';

export default class MobileAdUnit extends Component {
  static propTypes = {
    adService: PropTypes.shape({type: PropTypes.instanceOf(AdService)}),
    positionId: PropTypes.string,
    slotName: PropTypes.string,
    slotKeyValues: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.renderCount = 0;
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {adService, positionId, slotName, slotKeyValues} = this.props;

    this.renderCount++;

    return (
      <div>
        <AdController
          adService={adService}
          adSize={[[300, 250], [320, 100], [320, 50], [1, 1]]}
          clientLoadOnly
          pageName="fh-profile"
          positionId={positionId}
          slotName={slotName}
          slotKeyValues={slotKeyValues}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/Obituaries/MobileAdUnit.js